// profile

import homePage from '../pages/Home.vue'
import loginPage from '../pages/Login.vue'
import notFoundPage from '../pages/NotFound.vue'

import clasesPage from '../pages/Classes.vue'
import clasesViewPage from '../pages/ClassesView.vue'
import familiesPage from '../pages/Families.vue'
import familiesViewPage from '../pages/FamiliesView.vue'
import enrollmentsPage from '../pages/Enrollments.vue'
import billingPage from '../pages/Billing.vue'
import schedulePage from '../pages/Schedule.vue'
import configPage from '../pages/Config.vue'

import { DOMAIN_TITLE } from '../.env'

export const routes = [
  {
    path: '/',
    name: 'index',
    component: homePage,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | home` }
  },
  {
    path: '/login',
    name: 'login',
    component: loginPage,
    meta: { title: `${DOMAIN_TITLE} | login` }
  },
  {
    path: '/classes',
    name: 'clases',
    component: clasesPage,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Lista de Clases` }
  },
  {
    path: '/classes/:id',
    name: 'clases',
    component: clasesViewPage,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Ver Clases` }
  },
  {
    path: '/families',
    name: 'familias',
    component: familiesPage,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Lista de Familias` }
  },
  {
    path: '/families/:id',
    name: 'familia',
    component: familiesViewPage,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Ver Familia ` }
  },
  {
    path: '/enrollments',
    name: 'inscripciones',
    component: enrollmentsPage,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Lista de Inscripciones ` }
  },
  {
    path: '/billing',
    name: 'facturacion',
    component: billingPage,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Lista de Facturas ` }
  },
  {
    path: '/schedule',
    name: 'horarios',
    component: schedulePage,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Lista de Horarios ` }
  },
  {
    path: '/config',
    name: 'configuracion',
    component: configPage,
    meta: { isAuth: true, title: `${DOMAIN_TITLE} | Configuracion ` }
  },
  {
    path: '*',
    component: notFoundPage,
    meta: { title: `${DOMAIN_TITLE} | not found` }
  }
]
